import * as wasm from "./automerge_wasm_bg.wasm";
export * from "./automerge_wasm_bg.js";
import { __wbg_set_wasm } from "./automerge_wasm_bg.js";
__wbg_set_wasm(wasm);